import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ArchitectureDiagram, ArchitectureLayout, ChatMessage, InkDocument } from './architecture.models';

export const ArchitectureActions = createActionGroup({
  source: 'Architecture',
  events: {
    Load: emptyProps(),
    'Save Diagram': props<{ diagram: ArchitectureDiagram | null }>(),
    'Save Layout': props<{ layout: ArchitectureLayout | null }>(),
    'Save Ink': props<{ ink: InkDocument | null }>(),
    'Set Ink Draft': props<{ ink: InkDocument | null }>(),
    'Set Chat Messages': props<{ messages: ChatMessage[] }>(),
  },
});
